// extracted by mini-css-extract-plugin
export default {"pageTitle":"page-title_pageTitle__GB5V0"};